import { render, staticRenderFns } from "./popup-add.vue?vue&type=template&id=21e070ea&scoped=true"
import script from "./popup-add.vue?vue&type=script&lang=js"
export * from "./popup-add.vue?vue&type=script&lang=js"
import style0 from "./popup-add.vue?vue&type=style&index=0&id=21e070ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e070ea",
  null
  
)

export default component.exports